import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_garden_entertaining: FaireCategoryEntity = {
  token: "cat_garden-entertaining",
  type: "category",
  name: "Outdoor entertaining",
  level: 3,
  parentToken: "cat_home-decor-garden",
  href: "/category/home-decor/garden-outdoor/outdoor-entertaining",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
